module.exports = __webpack_public_path__ + "static/media/Office_party_mob.c36af933.jpg";